import * as tslib_1 from "tslib";
import { getStore } from '../store/tabStore';
import isTabViewEnabled from './isTabViewEnabled';
export default function getActiveTab() {
    var e_1, _a;
    if (isTabViewEnabled()) {
        var store = getStore();
        try {
            for (var _b = tslib_1.__values(store.tabs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var viewState = _c.value;
                if (viewState.isActive) {
                    return viewState;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return null;
}
//# sourceMappingURL=getActiveTab.js.map